import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
export function CriterioProfesional() {
  const comparisons = [{
    task: 'Analizás un caso sin saber por dónde empezar',
    without: 'Sin upsell',
    with: 'Protocolo de 6 pasos listo para aplicar'
  }, {
    task: 'Tu respuesta suena a "alumno que memorizó"',
    without: 'Sin upsell',
    with: 'Diccionario de 30 verbos de autoridad técnica'
  }, {
    task: 'El final integrador te paraliza',
    without: 'Sin upsell',
    with: '5 casos reales resueltos desde las corrientes'
  }, {
    task: 'Usás "básicamente" y "vendría a ser"',
    without: 'Sin upsell',
    with: 'Frases de autoridad que elevan tu nivel al instante'
  }];
  return <section className="py-6 px-4 max-w-3xl mx-auto" data-id="element-92">
      <FadeIn data-id="element-93">
        <h2 className="text-xl md:text-2xl font-bold text-center mb-5 flex items-center justify-center gap-2" data-id="element-94">
          <span className="text-2xl" data-id="element-95">🧠</span> ¿QUÉ AGREGA CRITERIO PROFESIONAL?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-96">
          <div className="grid grid-cols-3 bg-gray-800/80 border-b border-gray-700 p-2.5 font-bold text-xs md:text-sm" data-id="element-97">
            <div className="text-gray-400" data-id="element-98">Situación</div>
            <div className="text-red-400 text-center" data-id="element-99">Sin upsell</div>
            <div className="text-sky-400 text-center" data-id="element-100">
              Con Criterio Profesional
            </div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-101">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-2.5 items-center text-xs md:text-sm hover:bg-gray-800/30 transition-colors" data-id="element-102">
                <div className="font-medium text-gray-300 pr-2" data-id="element-103">
                  {item.task}
                </div>
                <div className="text-center text-gray-400 flex flex-col items-center gap-0.5" data-id="element-104">
                  <X size={14} className="text-red-500/50" data-id="element-105" />
                </div>
                <div className="text-center font-bold text-sky-400 flex flex-col items-center gap-0.5 bg-sky-900/10 py-1.5 rounded-lg px-2" data-id="element-106">
                  <Check size={14} className="text-sky-500" data-id="element-107" />
                  <span data-id="element-108">{item.with}</span>
                </div>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}